/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const TextStrokeIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Text Stroke',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M25 32H11a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h3V10h-4v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h26a1 1 0 0 1 1 1v7.973a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V10h-4v16h3a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1Zm-13-4v2h12v-2h-4V8h8v4h2V5.96H6V12h2V8h8v20ZM6 5v1Z"
    />
  </svg>`;
};
